// Websocket.onPing param
export type WebSocketMessageParams = {
  message?: OnMessageParams;
  topicUniqueId: string;
  type: string;
};

// SubscriptionManager.publish params
export type PubSubParams = {
  topicUniqueId: string;
  topic: string;
  messageType: string;
  data?: any;
  // Optional replay behavior for subscriptions that need snapshot semantics for
  // late subscribers. Delta-only streams can leave this undefined.
  subscriptionOptions?: SubscriptionReplayOptions;
};

// SubscriptionManager.onMessage params
// WebSocket.subscribeToMessage callback params
export type OnMessageParams = {
  error: boolean;
  meta?: any;
  responseType?: string | 'resubscribeAll' | 'removal' | 'DEBUG:SUBLIST:REQUEST';
  topicUniqueId: string;
  payload: any[];
};

// SharedClient, SharedClientWorker, ApplicationService
export type MessageRequest<Payload = any> = {
  messageType: MessageRequestType;
  topic: string;
  message: Payload;
  meta?: any;
  sender?: string;
};

export enum MessageRequestType {
  publish = 'publish',
  subscribe = 'subscribe',
  request = 'request',
  response = 'response',
  broadCast = 'broadCast',
}

export type SubscriptionReplayOptions = {
  replayStrategy?: string;
};
